import {Component, Inject, OnInit} from '@angular/core';
import {USER_VALIDATORS} from '../../../../constants/validators';
import {UserService} from '../../../services/api/user.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Role} from '../../../data/models/role';
import {RoleService} from '../../../services/api/role.service';
import {UserValidators} from '../../../validators/user-validators';

@Component({
  selector: 'app-user-create-dialog',
  templateUrl: './user-create-dialog.component.html',
  styleUrls: ['./user-create-dialog.component.css']
})
export class UserCreateDialogComponent implements OnInit {

  public userForm: FormGroup;
  public roles: Role[] = [];
  public passwordHide = true;

  constructor(
    private roleService: RoleService,
    private userService: UserService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {},
  ) {
    this.userForm = this.fb.group({
      mail: ['', USER_VALIDATORS.MAIL, [UserValidators.uniqueMailValidator(this.userService)]],
      password: ['', USER_VALIDATORS.PASSWORD],
      surname: ['', USER_VALIDATORS.SURNAME],
      name: ['', USER_VALIDATORS.NAME],
      patronymic: ['', USER_VALIDATORS.PATRONYMIC],
      roles: [[]],
    });
  }

  ngOnInit(): void {
    this.getRoles();
  }

  getRoles(): void {
    this.roleService.roles$
      .subscribe(roles => this.roles = roles);
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.userForm.valid) {
      this.userService.addUser({
        mail: this.userForm.controls.mail.value,
        password: this.userForm.controls.password.value,
        surname: this.userForm.controls.surname.value,
        name: this.userForm.controls.name.value,
        patronymic: this.userForm.controls.patronymic.value,
        roles: this.userForm.controls.roles.value,
      })
        .then(user => this.dialogRef.close(user))
        .catch(error => {
        });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
